module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Thin-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Thin-webfont.ttf
// module id = 1623
// module chunks = 0